module.exports = __webpack_public_path__ + "static/img/2bo.ca90600d.webp";